import { redirect } from 'react-router-dom';

export function logoutAction() {
  sessionStorage.clear();
  return redirect('/Login');
}